
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirebaseApp } from "../../config/firebase/firebaseClient";

const functions = getFunctions(getFirebaseApp());


export const callTransactionSearch = async (data) => {
    try {
        const getaeropayTransactionSearch = httpsCallable(functions, "aeropayTransactionSearch");
        const result = await getaeropayTransactionSearch(data);
        return result.data;
    } catch (error) {
        console.error("Error calling aeropayTransactionSearch function:", error);
        throw error;
    }
}
export const downloadAeropayCsv = async (data) => {
    try {
        const getAeropayTransactionsExportCsv = httpsCallable(functions, "aeropayTransactionExportCsv");
        const result = await getAeropayTransactionsExportCsv(data);
        return result.data;
    } catch (error) {
        console.error("Error calling aeropayTransactionsExportCsv function:", error);
        throw error;
    }
}

 